/**
 * @module app.bdc.reports.sepaCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function SepaCtrl($scope, $window, $rootScope, sepaType) {
        console.log(sepaType);
        var self = {};
        self.client = $rootScope.order.client;
        self.sepaType = sepaType === 'SRDMP' ? 'SRD MP' : sepaType;

        var emptyIBAN = ['F', 'R'];
        self.IBAN = self.client.IBAN
            ? self.client.IBAN.split('')
            : Array.apply(null, Array(27)).map(function(element, index) {
                return index == 0 || index == 1 ? emptyIBAN[index] : '\u200E';
            }); // Return array with a length of 27 starting with FR and then special spaces
        self.codeBic = self.client.codeBic
            ? self.client.codeBic.split('')
            : Array.apply(null, Array(11)).map(function() {
                return '\u200E';
            });
        self.idSepa = '';

        if (sepaType === 'BURALOG') {
            self.idSepa = 'FR83ZZZ514168';
            self.companyFooter =
                'SAS au capital de 85 800 euros - Siret : 491 286 753 000 42 - APE 4651 Z - TVA : FR 76 491 286 753';
        }
        else if (sepaType === 'SRD') {
            self.idSepa = 'FR33ZZZ520597';
            self.companyFooter =
                'SAS au capital de 300 000 euros - Siret : 492 300 520 - APE 4652 Z - TVA : FR 39 492 300 520';
        }
        else if (sepaType === 'SRDMP') {
            self.idSepa = 'FR94ZZZ564992';
            self.companyFooter =
                'SAS au capital de 10 000 euros - Siret : 517 485 017 - APE 4651 Z - TVA : FR 36 517 485 017';
        }
        else if (sepaType === 'VIEWME') {
            self.idSepa = 'FR56ZZZ634740';
        }

        self.idSepa = self.idSepa.split('');

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Generate the unique sepa report identifier
         * 3 letters lastName + 3 letters firstName + date : YYYYMMDD + postal code + sepa type
         * @return {String}
         */
        self.getNumero = function getNumero() {
            var num = '';

            num += self.client.lastName.slice(0, 3).toUpperCase();
            num += self.client.firstName.slice(0, 3).toUpperCase();
            num += moment().format('YYYYMMDD');
            num += self.client.addressPostalCode;

            if (self.sepaType === 'SRD MP') {
                return num + 'SMP';
            }

            if (self.sepaType === 'VIEWME') {
                return num + 'VME';
            }

            return num + self.sepaType.slice(0, 3);
        };
        // Modification du title de la page pour l"impression en PDF
        $window.document.title =
            self.client.lastName +
            '_' +
            self.client.firstName +
            '_' +
            'Mandat' +
            '_' +
            sepaType +
            '_' +
            moment().format('YYYYMMDD');

        return self;
    }

    SepaCtrl.$inject = ['$scope', '$window', '$rootScope', 'sepaType'];

    angular.module('app.bdc.reports.sepaCtrl', []).controller('SepaCtrl', SepaCtrl);

    return SepaCtrl;
});
